var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 3.28125C13.7289 3.28125 10.1124 4.77929 7.44583 7.44583C4.77929 10.1124 3.28125 13.7289 3.28125 17.5C3.28125 21.2711 4.77929 24.8876 7.44583 27.5542C10.1124 30.2207 13.7289 31.7188 17.5 31.7188C21.2711 31.7188 24.8876 30.2207 27.5542 27.5542C30.2207 24.8876 31.7188 21.2711 31.7188 17.5C31.7188 13.7289 30.2207 10.1124 27.5542 7.44583C24.8876 4.77929 21.2711 3.28125 17.5 3.28125ZM0 17.5C0 12.8587 1.84375 8.40752 5.12564 5.12564C8.40752 1.84375 12.8587 0 17.5 0C22.1412 0 26.5926 1.84375 29.8745 5.12564C33.1562 8.40752 35 12.8587 35 17.5C35 22.1412 33.1562 26.5926 29.8745 29.8745C26.5926 33.1562 22.1412 35 17.5 35C12.8587 35 8.40752 33.1562 5.12564 29.8745C1.84375 26.5926 0 22.1412 0 17.5ZM19.6875 24.0625C19.6875 24.6426 19.457 25.1991 19.0468 25.6093C18.6366 26.0194 18.0802 26.25 17.5 26.25C16.9198 26.25 16.3634 26.0194 15.9532 25.6093C15.543 25.1991 15.3125 24.6426 15.3125 24.0625C15.3125 23.4824 15.543 22.9259 15.9532 22.5157C16.3634 22.1056 16.9198 21.875 17.5 21.875C18.0802 21.875 18.6366 22.1056 19.0468 22.5157C19.457 22.9259 19.6875 23.4824 19.6875 24.0625ZM19.1406 10.3906C19.1406 9.95551 18.9678 9.5382 18.6601 9.23053C18.3524 8.92286 17.9351 8.75 17.5 8.75C17.0649 8.75 16.6476 8.92286 16.3399 9.23053C16.0322 9.5382 15.8594 9.95551 15.8594 10.3906V18.0469C15.8594 18.482 16.0322 18.8993 16.3399 19.207C16.6476 19.5146 17.0649 19.6875 17.5 19.6875C17.9351 19.6875 18.3524 19.5146 18.6601 19.207C18.9678 18.8993 19.1406 18.482 19.1406 18.0469V10.3906Z",
    fill: "#DC2727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconRed);
export default __webpack_public_path__ + "static/media/errorIconRed.5c59874f461363a4bf55443623229e35.svg";
export { ForwardRef as ReactComponent };